<template
  ><div class="v-template-builder-header" :class="extraClass">
    <div class="left-block">
      <span v-if="backBtn" class="goBack" @click="onBackClick"
        ><img :src="arrowBack" alt="go-back"
      /></span>
      <span v-if="!noLogo" class="logo"
        ><img :src="inkitLogo" alt="Inkit"
      /></span>

      <div class="template-name-wrapper" ref="leftblock">
        <span v-show="!isOpenInput" class="label">{{ label }}</span>
        <!--Form appears only when prop 'name' (name of form) exists-->
        <div id="form-container" v-if="name">
          <div class="form-wrapper" v-if="isOpenInput">
            <VForm
              :name="name"
              :initialValues="{ templateInput: label }"
              :fields="formFields"
            ></VForm>
          </div>
          <span
            class="button"
            ref="savebtn"
            @click="editInput"
            :class="{ active: isOpenInput }"
          >
            {{ btnValue }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="actions" class="right-block">
      <div v-for="(action, idx) of actions" :key="idx">
        <v-button
          v-if="!action.component"
          v-bind="action"
          @click="onClickAction(action)"
        ></v-button>

        <component v-else :is="action.component" v-bind="action.props" />
      </div>
    </div></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import { required, maxLength } from "@/utils/validations";
import VForm from "@/components/VForm";
import withNavigate from "@/mixins/withNavigate";
import withFormUtils from "@/mixins/withFormUtils";

//assets
import inkitLogo from "@/assets/images/logo-w-container.svg";
import arrowBack from "@/assets/images/arrow-left.svg";

export default Vue.component("VLayoutHeader", {
  props: {
    label: VueTypes.string,
    name: VueTypes.string,
    backBtn: VueTypes.bool.def(false),
    noLogo: VueTypes.bool.def(false),
    extraClass: VueTypes.string,
    actions: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.string.isRequired,
        type: VueTypes.string.def("primary"),
        noBorder: VueTypes.bool.def(false),
        inverted: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        size: VueTypes.string,
        click: VueTypes.oneOfType([VueTypes.func, VueTypes.string]).isRequired
      })
    ),
    maxLength: VueTypes.number.def(255)
  },

  data() {
    return {
      isOpenInput: false,
      btnValue: "Edit",
      inkitLogo,
      arrowBack
    };
  },

  components: {
    VForm
  },

  mixins: [withFormUtils, withNavigate],

  computed: {
    formFields() {
      return [
        {
          name: "templateInput",
          elementType: "text",
          extraClass: "wide",
          validate: [required, maxLength(this.maxLength)]
        }
      ];
    }
  },

  methods: {
    onBackClick() {
      this.goBack();
    },

    handleDocumentClick(e) {
      e.stopPropagation();

      const { leftblock, savebtn } = this.$refs;
      const target = e.target;

      if (
        this.isOpenInput &&
        target !== savebtn &&
        target !== leftblock &&
        !leftblock.contains(target)
      ) {
        this.editInput();
      }
    },

    editInput() {
      if (!this.isOpenInput) {
        this.btnValue = "Save";
        this.isOpenInput = !this.isOpenInput;
      } else {
        this.validateForm();

        if (this.formValues.templateInput === this.label) {
          this.isOpenInput = !this.isOpenInput;
          this.btnValue = "Edit";
        } else if (this.isValid) {
          this.$emit("save", this.formValues.templateInput);
          this.btnValue = "Edit";
          this.isOpenInput = !this.isOpenInput;
        }
      }
    },

    onDocumentKeyUpHandler(e) {
      if (e.key === "Enter" && this.isOpenInput) {
        this.editInput();
      }
    },

    onClickAction(action) {
      if (typeof action.click === "string") {
        this.$emit(action.click, action.value);
      } else {
        action.click(action.value);
      }
    }
  },

  created() {
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.onDocumentKeyUpHandler);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.onDocumentKeyUpHandler);
  }
});
</script>

<style lang="scss" scoped>
.v-template-builder-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /*margin-bottom: 50px;*/
  width: 100%;

  .right-block {
    display: flex;
    align-items: center;

    > * {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .left-block {
    display: flex;
    align-items: center;

    .logo {
      display: inline-block;
      margin-right: 22px;
    }

    .goBack {
      display: inline-block;
      margin-right: 15px;
      cursor: pointer;
      height: 14px;
    }

    .template-name-wrapper {
      display: flex;
      font-family: Lato-Bold, Arial, sans-serif;
      font-style: normal;
      font-size: 22px;
      align-items: center;
      color: #4e4e4e;
    }

    .label {
      max-width: 415px;
      line-height: 33px;
      @include textCropEllipsis();
    }

    #form-container {
      display: flex;
      align-items: center;
    }

    .form-wrapper {
      align-items: flex-start;
      /deep/ {
        .wide {
          width: 415px;
        }

        .error {
          position: absolute;
          top: 30px;
        }
      }
    }

    .button {
      display: inline-block;
      height: 30px;
      line-height: 33px;
      cursor: pointer;
      font-family: Lato-Regular, Arial, sans-serif;
      font-style: normal;
      font-size: 12px;
      align-items: center;
      color: $primary-grey;
      margin-left: 10px;

      &.active {
        color: $primary-color;
      }
    }
  }
}
</style>
